import * as React from 'react';
import { Button } from '@symphony-ui/uitoolkit-components';
import RenderingContext from 'contexts/RenderingContext';
import Maturity from '../../../../models/data/Maturity';
const MaturityCellDateSelector = ({ isDisabled, setValueConfirm, save, value, }) => {
    const { printDate } = React.useContext(RenderingContext);
    const onClickDate = React.useCallback((mode) => () => {
        const newValue = new Maturity({
            date: {
                dayOfMonth: mode === 'OK' ? value.date?.dayOfMonth : undefined,
                monthValue: (mode === 'OK' || mode === 'M') ? value.date?.monthValue ?? 0 + 1 : undefined,
                year: value.date?.year
            }
        });
        (async () => {
            setValueConfirm(false);
            await save(newValue);
        })();
    }, [value, save, setValueConfirm]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { fontWeight: 'bold', margin: '1rem', textAlign: 'center' } }, value.date !== undefined
            ? printDate(new Date(Date.UTC(value.date.year ?? 2000, (value.date.monthValue ?? 1) - 1, value.date.dayOfMonth)), { precision: 'YMD' })
            : ''),
        React.createElement("div", { style: { display: 'flex', marginLeft: '10px' } },
            React.createElement(Button, { disabled: isDisabled, onClick: onClickDate('OK'), variant: "tertiary-accent" }, "OK"),
            React.createElement(Button, { disabled: isDisabled, onClick: onClickDate('M'), variant: "tertiary" }, "Month"),
            React.createElement(Button, { disabled: isDisabled, onClick: onClickDate('Y'), variant: "tertiary" }, "Year"))));
};
export default MaturityCellDateSelector;
